<br />
<button
  (click)="addProvider()"
  [disabled]="isLoading"
  mat-raised-button
  color="primary"
>
  <mat-icon [inline]="true">add </mat-icon>&nbsp;Add a new provider
</button>
<mat-action-list>
  <mat-list-item *ngFor="let provider of filteredProviders">
    <div mat-line>{{ provider.url }}</div>
    <div class="provider-list-subtitle" mat-line>{{ provider.type }}</div>

    <button mat-icon-button (click)="editProvider(provider)">
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button (click)="removeProvider(provider)">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-list-item>
  <mat-list-item *ngIf="filteredProviders.length === 0">
    No providers configured
  </mat-list-item>
</mat-action-list>
